import {IMedicationAdherence} from 'redux/intervention/interfaces';

export interface IAdherenceSummary {
  // Null until at least one dose has been resolved.
  percent: number | null
  taken: number
  expected: number
}

export function toPercent(fraction: number): number {
  return Math.round(fraction * 100);
}

// One medication's rate. A medication with nothing resolved yet has no percentage.
export function medicationPercent(row: IMedicationAdherence): number | null {
  if (row.adherenceRate === null || row.dosesExpected <= 0) {
    return null;
  }

  return toPercent(row.adherenceRate);
}

// The overall rate across all medications, weighted by expected doses (same as the admin tab).
export function summarizeAdherence(rows: IMedicationAdherence[]): IAdherenceSummary {
  const taken = rows.reduce((sum, row) => sum + row.dosesTaken, 0);
  const expected = rows.reduce((sum, row) => sum + row.dosesExpected, 0);

  return {percent: expected > 0 ? toPercent(taken / expected) : null, taken, expected};
}
